module.exports = "<div *ngIf=\"renderCountdown\" class=\"timer\">\n  <span>{{message}} {{hoursToDday}}:{{minutesToDday}}:{{secondsToDday}} ...</span>\n</div>"